import { EstimationInput } from '../../App';
import { EmissionCalculationInTonnes } from '../../configs/industryCalculationTemplate';

export const calculateYachtingBoating = (
  input: EstimationInput,
): EmissionCalculationInTonnes => {
  const { employees: litres } = input;

  const tonnes = 0.00245 * litres;
  return tonnes;
};
